<template>
  <div class="workscore-detail atb-flex atb-flex-column">
    <div class="header atb-flex atb-flex-items-center">
      <div class="month-title">
        <h2 v-if="detail.year">{{ detail.year }}{{ periods[detail.period] }} / {{ detail.wkName }}</h2>
        <span class="saveStatus">{{ saveStatus }}</span>
      </div>
    </div>
    <div class="container atb-content-bg atb-flex atb-flex-column">
      <div class="tab atb-flex atb-flex-justify-between">
        <tab-pane :defaultIndex="currentTab" :tab-list="tabList" iconStyle="top" @getCurrent="getCurrent"></tab-pane>
      </div>
      <div v-show="currentTab === 0" class="search-and-content atb-flex atb-flex-column" id="all">
        <div class="search">
          <div class="function atb-flex">
            <el-form :inline="true" class="atb-input">
              <el-form-item v-if="editStatus !== 'approve' && !isPublished">
                <el-button :disabled="pending" type="primary" @click="saveAll">保存</el-button>
              </el-form-item>
              <el-form-item v-if="editStatus !== 'approve' && !isPublished">
                <el-button type="primary" @click="showSubmit = true">提交</el-button>
              </el-form-item>
              
              <el-form-item v-if="isApprove">
                <el-button type="primary" @click="showApprove = true">通过</el-button>
              </el-form-item>
              <el-form-item v-if="isApprove">
                <el-button type="refuse" @click="showCompleteApprove = true">驳回</el-button>
              </el-form-item>
              <el-form-item v-if="isApproved">
                <el-button :disabled="pending" type="downloadTemplate" plain @click="showConfirmScore">确认</el-button>
              </el-form-item>
              <el-form-item v-if="msgId && editStatus === 'edit'">
                <el-button plain type="downloadTemplate" @click="showApproveReason = true">审批意见</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="downloadTemplate" plain @click="exportExcel">导出</el-button>
              </el-form-item>
              <el-form-item>
                <el-button plain type="downloadTemplate" @click="expandRowAll">{{expandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content atb-flex atb-flex-column kpi">
          <vxe-table
            class="atb-table header-table edit-table border-table disable-ellipsis"
            border="full"
            height="100%"
            auto-resize
            resizable
            :data="tableData"
            ref="workScoreTable"
            :merge-cells="mergeCells"
            :row-class-name="setRowClass"
            :edit-config="{ trigger: 'click', mode: 'row', activeMethod: editActived }"
            @edit-closed="editClosed"
            @edit-actived="activeRow"
            @cell-click="expandRow"
            :edit-rules="validRules"
            :scroll-y="{enabled: false}"
          >
            <vxe-table-column field="_none" width="40" :edit-render="{ enabled: colCase, autofocus: '.el-textarea__inner' }">
              <template #default="scope">
                <template v-if="scope.rowIndex === 0">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <i @click="expandNewKpi" :class="[expandNewKPIStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                      <span @click="expandNewKpi">新增KPI工作</span>
                      <i v-throttle v-if="isEditable" @click.stop="addNewKpi" class="icon-add"></i>
                    </div>
                    <span v-throttle v-if="isEditable" @click.stop="addNewKpi(scope.row)">新增</span>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === newKPILength + 1">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <i @click="expandImportantKPI" :class="[expandImportantKPIStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                      <span @click="expandImportantKPI">重要KPI工作</span>
                    </div>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === newKPILength + importantKPILength + 2">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div>
                      <i @click="expandBussiness" :class="[expandBussinessStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                      <span @click="expandBussiness">综合业务性工作</span>
                      <i v-throttle v-if="isEditable" @click.stop="addBussiness" class="icon-add"></i>
                    </div>
                    <span v-throttle v-if="isEditable" @click.stop="addBussiness">新增</span>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === newKPILength + importantKPILength + bussinessLength + 3">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div style="cursor: default;" class="required-field">杰出案例</div>
                  </div>
                </template>
                <template v-else-if="scope.row.isOutstandingCase">
                  <div :class="[scope.row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ detail.outstandingCase }}</div>
                </template>
                <template v-else-if="scope.rowIndex === newKPILength + importantKPILength + bussinessLength + 5">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div style="cursor: default;" class="required-field">自评等级</div>
                  </div>
                </template>
                <template v-else-if="scope.row.isSelf">
                  <div class="atb-flex atb-flex-justify-between atb-flex-items-center">
                    <el-radio-group class="radio-group" v-model="detail.selfEvaluation" @change="selfLevelChange" :disabled="!isEditable">
                      <el-radio v-for="(item, i) in selfLevels" :key="i" :label="item.label">{{item.label}}</el-radio>
                    </el-radio-group>
                  </div>
                </template>
                <template v-else-if="scope.rowIndex === newKPILength + importantKPILength + bussinessLength + 7 && (isApproved || isConfirmed || isPublished)">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div style="cursor: default;" class="required-field">
                      <span>综合评分</span>
                      <!-- <el-popover
                        width="600"
                        trigger="hover"
                      >
                        <span slot="reference" class="rank-tip">（评分标准）</span>
                        <table class="rank-tip-table">
                          <thead>
                            <tr>
                              <th width="60" align="center">标准</th>
                              <th width="80" align="center">分值区间</th>
                              <th align="center">标准说明</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td align="center">出色</td>
                              <td align="center">100</td>
                              <td>工作绩效始终超越本职位常规标准要求，通常具有下列表现：在规定的时间之前完成任务，完成任务的数量、质量等明显超出规定的标准，得到来自客户的高度评估。</td>
                            </tr>
                            <tr>
                              <td align="center">优良</td>
                              <td align="center">90</td>
                              <td>工作绩效经常超出本职位常规标准要求，通常具有下列表现：严格按照规定的时间要求完成任务并经常提前完成任务，经常在数量、质量上超出规定的标准，获得客户的满意。</td>
                            </tr>
                            <tr>
                              <td align="center">可接受</td>
                              <td align="center">80</td>
                              <td>工作绩效经常维持或偶尔超出本职位常规标准要求，通常具有下列表现；基本上达到规定的时间、数量、质量等工作标准，没有客户不满。</td>
                            </tr>
                            <tr>
                              <td align="center">需改进</td>
                              <td align="center">70</td>
                              <td>需改进，工作绩效基本维持或偶尔未达本职位常规标准要求，通常具有下列表现：偶有小的疏漏，有时在时间、数量、质量上达不规定的工作标准，偶尔有客户的投诉。</td>
                            </tr>
                            <tr>
                              <td align="center">不良</td>
                              <td align="center">60<br/>30<br/>0</td>
                              <td>工作绩效显著低于常规本职位正常工作标准的要求，通常具有下列表现：工作中出现大的失误，或在时间、数量、质量上达不到规定的工作标准，经常突击完成任务、经常有投诉发生。</td>
                            </tr>
                          </tbody>
                        </table>
                      </el-popover> -->
                    </div>
                  </div>
                </template>
                <template v-else-if="scope.row.isSup && (isApproved || isConfirmed || isPublished)">
                  <div class="atb-flex atb-flex-justify-between atb-flex-items-center">{{ detail.supScore }}</div>
                </template>
                <template v-else>
                  
                </template>
              </template>
              <template #edit="{ row, rowIndex, column }">
                <template v-if="rowIndex === newKPILength + importantKPILength + bussinessLength + 4">
                  <el-input
                    type="textarea"
                    :maxlength="$config.input.textareaMaxLength"
                    :autosize="{ maxRows: 8 }"
                    placeholder="请输入内容"
                    v-model="detail.outstandingCase"
                  ></el-input>
                </template>
                <template v-else-if="row.isSup && (isApproved || isConfirmed || isPublished)">
                  <el-input
                    v-model.trim="detail.supScore"
                    type="textarea"
                    :autosize="{ maxRows: 1 }"
                    resize="none"
                    maxlength="5"
                    oninput="value = value.replace(/[^\.\d]/g,'')"
                    @change="(val) => supScoreChange(val, row, column)"
                  ></el-input>
                  <!-- <el-autocomplete @change="regScore(row)" v-model.trim="row.score" :fetch-suggestions="scoreSearch"></el-autocomplete> -->

                </template>
              </template>
            </vxe-table-column>
            <vxe-table-column field="source" width="50" title="月份">
              <template #default="{row}">
                <span v-if="row.source">{{ row.source }}月</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="60"
              width="100"
              field="workItemCategory"
              title="类别"
              :edit-render="{ name: 'ElAutocomplete', enabled: isEditable && colCategory, autofocus: '.el-textarea__inner' }"
            >
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemCategory }}</div>
              </template>
              <template #edit="{ row }">
                <el-autocomplete v-model.lazy="row.workItemCategory" type="textarea" :autosize="{ maxRows: 8 }" :fetch-suggestions="querySearch">
                  <template slot-scope="{ item }">
                    <el-tooltip class="item" effect='dark' :content="item.value" placement="right-start">
                      <div class="query-item-text atb-ellipsis">{{ item.value }}</div>
                    </el-tooltip>
                  </template>
                </el-autocomplete>
              </template>
            </vxe-table-column>
            <vxe-table-column
              min-width="100"
              :width="150"
              field="workItemContent"
              title="工作项目"
              :edit-render="{ enabled: isEditable && colWorkItem, autofocus: '.el-textarea__inner' }"
            >
              <template #edit="{ row }">
                <el-input
                  type="textarea"
                  :maxlength="$config.input.textareaMaxLength"
                  :autosize="{ maxRows: 8 }"
                  placeholder="请输入内容"
                  v-model="row.workItemContent"
                ></el-input>
              </template>
              <template #default="scope">
                <div class="atb-flex atb-flex-items-center">
                  <div :class="[scope.row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ scope.row.workItemContent }}</div>
                </div>
              </template>
            </vxe-table-column>
  
            <vxe-table-column
              min-width="80"
              width="250"
              field="wholeTarget"
              title="总目标"
              :edit-render="{ enabled: isEditable && colTarget, autofocus: '.el-textarea__inner' }"
            >
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
              </template>
              <template #edit="{ row }">
                <el-input
                  type="textarea"
                  :maxlength="$config.input.textareaMaxLength"
                  :autosize="{ maxRows: 8 }"
                  placeholder="请输入内容"
                  v-model="row.wholeTarget"
                ></el-input>
              </template>
            </vxe-table-column>
            
            <vxe-table-column min-width="80" width="250" field="reason" title="总结" :edit-render="{ enabled: (isEditable || isApproved) && colSummary, autofocus: '.el-textarea__inner' }">
              <template #default="{row, rowIndex}">
                <template v-if="rowIndex === newKPILength + importantKPILength + bussinessLength + 5">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div style="cursor: default;" class="required-field">自评原因</div>
                  </div>
                </template>
                <template v-else-if="row.isSelf">
                  <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ detail.selfEvaluationReason }}</div>
                </template>
                <template v-if="rowIndex === newKPILength + importantKPILength + bussinessLength + 7 && (isApproved || isConfirmed || isPublished)">
                  <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                    <div style="cursor: default;" class="required-field">综合评价</div>
                  </div>
                </template>
                <template v-else-if="row.isSup">
                  <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ detail.supEvaluation }}</div>
                </template>
                <template v-else>
                  <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.reason }}</div>
                </template>
              </template>
              <template #edit="{ row }">
                <!-- 自评原因 -->
                <template v-if="row.isSelf">
                  <el-input
                    type="textarea"
                    :maxlength="$config.input.textareaMaxLength"
                    :autosize="{ maxRows: 2 }"
                    placeholder="请输入内容"
                    v-model="detail.selfEvaluationReason"
                  ></el-input>
                </template>
                <!-- 综合评价 -->
                <template v-else-if="row.isSup && (isApproved || isConfirmed || isPublished)">
                  <el-input
                    type="textarea"
                    :maxlength="$config.input.textareaMaxLength"
                    :autosize="{ maxRows: 2 }"
                    placeholder="请输入内容"
                    v-model="detail.supEvaluation"
                    @blur="growUpSave"
                  ></el-input>
                </template>
                <template v-else>
                  <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.reason"></el-input>
                </template>
              </template>
            </vxe-table-column>
            <vxe-table-column min-width="240" field="selfAppraise" title="自我对工作完成情况进行评估" :edit-render="{ enabled: isEditable, autofocus: '.el-textarea__inner' }">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.selfAppraise }}</div>
              </template>
              <template #edit="{ row }">
                <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.selfAppraise"></el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column field="" title="操作" fixed="right" width="100" class-name="operation" v-if="isEditable">
              <template #default="scope">
                <div v-if="isEditable && (scope.row.type == 0 || scope.row.type == 10)">
                  <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
                    <i v-throttle class="icon-baocun" @click.stop="save(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                  
                  <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                    <i v-throttle class="icon-close delete" @click.stop="deleteData(scope.row, scope.rowIndex)"></i>
                  </el-tooltip>
                </div>
              </template>
            </vxe-table-column>
            
          </vxe-table>
        </div>
      </div>
      <div v-show="currentTab === 1" class="search-and-content atb-flex atb-flex-column" id="normal">
        <div class="search">
          <div class="function atb-flex">
            <el-form :inline="true" class="atb-input">
              <el-form-item v-if="isApproved">
                <el-button :disabled="pending" type="primary" @click="growUpSave">保存</el-button>
              </el-form-item>
              <el-form-item v-if="isApproved">
                <el-button :disabled="pending" type="downloadTemplate" plain @click="showConfirmScore">确认</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content atb-flex atb-flex-column normal">
          <table class="personal-table">
            <thead>
              <tr class="label-row">
                <td width="25%"><div class="personal-label">绩效平均分(自动计算仅参考)</div></td>
                <td width="25%"><div class="personal-label required-field">绩效得分(满分100分)</div></td>
                <td width="25%"><div class="personal-label required-field">企业文化导向得分(满分100分)</div></td>
                <td width="25%"><div class="personal-label required-field">个人成长得分(满分100分)</div></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span>{{ detail.avgkpi }}</span></td>
                <td>
                  <div class="default-score" @click="toFocusField(100)" v-if="defaultScore[100]">{{ personalForm[100] }}</div>
                  <el-input
                    v-else
                    ref="score100"
                    v-model.trim="personalForm[100]"
                    oninput="value = value.replace(/[^\.\d]/g,'')"
                    @change="(val) => scoreChange(val, 100)"
                    @blur="blurField(100)"
                  ></el-input>
                </td>
                <td>
                  <div class="default-score" @click="toFocusField(110)" v-if="defaultScore[110]">{{ personalForm[110] }}</div>
                  <el-input
                    v-else
                    ref="score110"
                    v-model.trim="personalForm[110]"
                    oninput="value = value.replace(/[^\.\d]/g,'')"
                    @change="(val) => scoreChange(val, 110)"
                    @blur="blurField(110)"
                  ></el-input>
                </td>
                <td>
                  <div class="default-score" @click="toFocusField(120)" v-if="defaultScore[120]">{{ personalForm[120] }}</div>
                  <el-input
                    v-else
                    ref="score120"
                    v-model.trim="personalForm[120]"
                    oninput="value = value.replace(/[^\.\d]/g,'')"
                    @change="(val) => scoreChange(val, 120)"
                    @blur="blurField(120)"
                  ></el-input>
                </td>
              </tr>

              <tr class="label-row">
                <td colspan="4"><div class="personal-label">上级对该员工主要优缺点的总结</div></td>
              </tr>
              <tr>
                <td colspan="4">
                  <div>
                    <span class="required-field">优点：</span>
                    <el-checkbox-group class="checkbox-group" v-model="personalForm.advantage" @change="checkedAdvantageChange" :disabled="!isApproved">
                      <el-checkbox v-for="item in personalAdvantages" :label="item" :key="item.value">{{item}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="other-field">
                    <el-input
                      :maxlength="$config.input.textareaMaxLength - 300"
                      type="textarea" :autosize="{ maxRows: 6 }"
                      rows="1"
                      v-model="personalForm.otherAdvantage"
                      @blur="growUpSave"
                      :disabled="!isApproved || otherAdvantageDisabled"
                      placeholder="其他优点"
                    ></el-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div>
                    <span class="required-field">缺点：</span>
                    <el-checkbox-group class="checkbox-group" v-model="personalForm.disadvantage" @change="checkedDisadvantageChange" :disabled="!isApproved">
                      <el-checkbox v-for="item in personalDisadvantages" :label="item" :key="item.value">{{item}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="other-field">
                    <el-input
                      :maxlength="$config.input.textareaMaxLength - 300"
                      type="textarea" :autosize="{ maxRows: 6 }"
                      rows="1"
                      v-model="personalForm.otherDisadvantage"
                      @blur="growUpSave"
                      :disabled="!isApproved || otherDisadvantageDisabled"
                      placeholder="其他缺点"
                    ></el-input>
                  </div>
                </td>
              </tr>

              <tr class="label-row">
                <td colspan="4"><div class="personal-label">员工目前绩效改进情况和存在问题</div></td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="atb-flex atb-flex-items-center">
                    <div class="area-label required-field">上期改进计划：</div>
                    <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" v-model="detail.lastImprovePlan" @blur="growUpSave" :disabled="!isApproved"></el-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="atb-flex atb-flex-items-center">
                    <div class="area-label required-field">改进情况：</div>
                    <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" v-model="detail.improveDetail" @blur="growUpSave" :disabled="!isApproved"></el-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="atb-flex atb-flex-items-center">
                    <div class="area-label required-field">存在的问题：</div>
                    <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" v-model="detail.problem" @blur="growUpSave" :disabled="!isApproved"></el-input>
                  </div>
                </td>
              </tr>

              <tr class="label-row">
                <td colspan="4"><div class="personal-label required-field">员工绩效改进计划</div></td>
              </tr>
              <tr>
                <td colspan="4">
                  <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" v-model="detail.improvePlan" @blur="growUpSave" :disabled="!isApproved"></el-input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
   
    <el-dialog
      title="审批意见"
      :visible.sync="showApprove"
      width="500px"
      @close="closeApprove"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" :maxlength="$config.input.textareaMaxLength" placeholder="审批通过原因可不填" v-model="approveReason"> </el-input>
        <fast-approve @approveText="approveText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="updateStatus('access')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showApprove = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showCompleteApprove"
      width="500px"
      @close="closeApprove"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" :maxlength="$config.input.textareaMaxLength" placeholder="审批驳回原因必须填写" v-model="approveReason"> </el-input>
        <fast-approve @approveText="approveText"></fast-approve>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="updateStatus('refuse')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showCompleteApprove = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提交" :visible.sync="showSubmit" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content sub-content">
        <h2>确定要提交吗?</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showSubmit = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showApproveReason"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="footer-center"
    >
      <div class="content">
        {{ detail.approveReason || '无' }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-cancel" type="cancel" @click="showApproveReason = false">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="确认" :visible.sync="isShowConfirmScore" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content sub-content">
        <h2>确定要提交吗?</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmScore">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowConfirmScore = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import routeMixin from '@/mixins/route.mixin';
import {
  PERIODS,
  OEC_LEVEL
} from '@/utils/period-enum.js';

export default {
  name: 'workscoreDetail',
  inject: ['reload'],
  mixins: [routeMixin],
  data() {
    const workItemCategory = ({ cellValue, row }) => {
      if (!cellValue && (row.type === 0 || row.type === 10)) {
        return new Error('"类别"为必填项');
      }
    };
    const workItemContent = ({ cellValue, row }) => {
      if (!cellValue && (row.type === 0 || row.type === 10)) {
        return new Error('"工作项目"为必填项');
      }
    };
    const wholeTarget = ({ cellValue, row }) => {
      if (!cellValue && (row.type === 0 || row.type === 10)) {
        return new Error('"总目标"为必填项');
      }
    };
    const reason = ({ cellValue, row }) => {
      if (!cellValue && (row.type === 0 || row.type === 10)) {
        return new Error('"总结"为必填项');
      }
    };
    const selfAppraise = ({ cellValue }) => {
      if (!cellValue) {
        return new Error('"自我对工作完成情况进行评估"为必填项');
      }
    };

    return {
      validRules: {
        workItemCategory: [{ required: true, validator: workItemCategory, message: '"类别"为必填项' }],
        workItemContent: [{ required: true, validator: workItemContent, message: '"工作项目"为必填项' }],
        wholeTarget: [{ required: true, validator: wholeTarget, message: '"总目标"为必填项' }],
        reason: [{ required: true, validator: reason, message: '"总结"为必填项' }],
        selfAppraise: [{ required: true, validator: selfAppraise, message: '"自我对工作完成情况进行评估"为必填项' }],
      },
      scoreId: '',
      currentTab: 0,

      showApprove: false,
      showCompleteApprove: false,
      showSubmit: false,

      mergeCells: [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 3, col: 0, rowspan: 1, colspan: this.tableColumnLength },
      ],
      categoryList: [],

      timer: null,
      row: {},
      rowIndex: 0,
      tableColumn: [],
      editStatus: '',
      approveReason: '',
      approveRow: null,
      saveStatus: '',
      timeoutSave: '',
      timeoutAutoSave: '',

      colCategory: true,
      colWorkItem: true,
      colTarget: true,
      colSummary: true,
      colCase: true,

      rowData: {
        "id": null,
        "lastModificationTime": "",
        "lastModifierId": null,
        "scoreId": null,
        "type": 0,
        "source": null,
        "sourceId": "",
        "sourceCreationTime": "",
        "workClassify": 0,
        "workItemNo": "",
        "workItemCategory": "",
        "workItemContent": "",
        "resWkNo": sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkNo : '',
        "resWkName": sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkName : '',
        "wholeTarget": "",
        "reason": "",
        "selfAppraise": "",
        "appraise": "",
        "score": 0,
        "remark": ""
      },
      
      pending: false,
      autoSaving: false, //是否在自动保存中
      isPreventSave: false, //是否阻止了自动保存,
      expandRowAllFlag: false,

      scoreList: [{ value: 100 }, { value: 90 }, { value: 80 }, { value: 70 }, { value: 60 }, { value: 30 }, { value: 0 }],
      periods: PERIODS,
      status: -1,
      detail: {},

      newKPI: [],
      importantKPI: [],
      bussiness: [],
      cloneNewKPI: [],
      cloneImportantKPI: [],
      cloneBussiness: [],
      expandNewKPIStatus: true,
      expandImportantKPIStatus: true,
      expandBussinessStatus: true,

      outstandingCase: '',
      selfEvaluation: '',
      selfEvaluationReason: '',
      selfLevels: OEC_LEVEL,


      itemLimitNums: {
        noImportKPIMax: 20,
        haveImportKPIMax: 5,
        bussinessMax: 1,
        kpiMax: 20
      },
      hasImportKPI: false,


      personalForm: {
        100: '', // 绩效分
        110: '', // 企业文化导向得分
        120: '', // 个人成长得分
        advantage: [], // 优点
        disadvantage: [], // 缺点
        otherAdvantage: '', // 其他-优点
        otherDisadvantage: '', // 其他-缺点
      },

      advantages: [],
      disadvantages: [],

      submittedAdvantages: [],
      submittedDisadvantages: [],

      defaultScore: {
        100: true,
        110: true,
        120: true,
      },

      showApproveReason: false,
      isShowConfirmScore: false,
    };
  },
  watch: {
    tableColumnLength() {
      this.mergeCells = [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 4, col: 0, rowspan: 1, colspan: this.isEditable ? this.tableColumnLength - 1 : this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 5, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 5, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 6, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 6, col: 5, rowspan: 1, colspan: this.isEditable ? this.tableColumnLength - 6 : this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 7, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 7, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 8, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 8, col: 5, rowspan: 1, colspan: this.isEditable ? this.tableColumnLength - 6 : this.tableColumnLength - 5 },
      ];
    },

    newKPILength() {
      this.setMerge();
    },
    importantKPILength() {
      this.setMerge();
    },
    bussinessLength() {
      this.setMerge();
    },
    otherLength() {
      this.setMerge();
    },
    
  },
  computed: {
    tableData() {
      if (this.isApproved || this.isConfirmed || this.isPublished) {
        return [{}, ...this.newKPI, {}, ...this.importantKPI, {}, ...this.bussiness, {}, { isOutstandingCase: true }, {}, { isSelf: true }, {}, { isSup: true }];
      } else {
        return [{}, ...this.newKPI, {}, ...this.importantKPI, {}, ...this.bussiness, {}, { isOutstandingCase: true }, {}, { isSelf: true }];
      }
    },
    tableColumnLength() {
      return this.tableColumn.filter((val) => val.visible).length;
    },

    // 已保存/已驳回
    isEditable() {
      return this.editStatus === 'edit' && (this.status == 0 || this.status == 10);
    },
    // 已提交，需要审批
    isApprove() {
      return this.editStatus === 'approve' && this.status == 20;
    },
    // 已通过审批
    isApproved() {
      return this.editStatus === 'approve' && this.status == 30;
    },
    // 已确认
    isConfirmed() {
      return this.editStatus === 'approve' && this.status == 40;
    },
    // 已公示
    isPublished() {
      return this.status == 50;
    },
    tabList() {
      // return [{ label: '员工绩效考核表', id: 0 }, { label: '员工个人发展部分', id: 1 }];
      return (this.isApproved || this.isPublished || this.isConfirmed)
      ? [{ label: '员工绩效考核表', id: 0 }, { label: '员工个人发展部分', id: 1 }]
      : [{ label: '员工绩效考核表', id: 0 }];
    },
    newKPILength() {
      return this.newKPI.length;
    },
    importantKPILength() {
      return this.importantKPI.length;
    },
    bussinessLength() {
      return this.bussiness.length;
    },
    personalAdvantages() {
      if (this.status == 40 || this.status == 50) {
        return this.submittedAdvantages;
      } else {
        return this.advantages;
      }
    },
    personalDisadvantages() {
      if (this.status == 40 || this.status == 50) {
        return this.submittedDisadvantages;
      } else {
        return this.disadvantages;
      }
    },
    otherAdvantageDisabled() {
      return !this.personalForm.advantage.includes('其他');
    },
    otherDisadvantageDisabled() {
      return !this.personalForm.disadvantage.includes('其他');
    },
  },
  created() {
    this.scoreId = this.$route.query.id || '';
    this.rowData.scoreId = this.scoreId;
    this.msgId = this.$route.query.msgId || null;
    this.editStatus = this.$route.query.editStatus || '';

    this.getCategory();
  },
  mounted() {
    this.getLimitNum();
    this.getAdvantageDisAdvantage();
    this.getList();
    this.$nextTick(() => {
      this.tableColumn = (this.$refs.workScoreTable && this.$refs.workScoreTable.getColumns()) || [];
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {

    regScore(row) {
      let val = row.score;
      if(!val) val = '';
      val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
      val = val && parseFloat(val);
      if (val - 0 > 100) {
        val = 100;
      }
      if (val - 0 < 0) {
        val = 0;
      }
      row.score = val;
    },
    getLimitNum() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'WorkItemLimitMonth' }).then((res)=>{
        if(res.code === 0) {
          let list = (res.data && res.data.rows) || [];
          list.forEach(item => {
            switch (item.itemKey) {
              case 'KPI_NO':
                this.itemLimitNums.noImportKPIMax = item.itemValue ? parseInt(item.itemValue) : 20;
                break;
              case 'KPI_Have':
                this.itemLimitNums.haveImportKPIMax = item.itemValue ? parseInt(item.itemValue) : 5;
                break;
              case 'SumWork':
                this.itemLimitNums.bussinessMax = item.itemValue ? parseInt(item.itemValue) : 1;
                break;
              default:
                break;
            }
          });
        }
      });
    },

    approveText(e) {
      this.approveReason = e;
    },

  
    expandRowAll() {
      if (this.expandRowAllFlag) {
        this.tableData.forEach(val => {
          val.expandRowFlag = false;
        });
     }else {
        this.tableData.forEach(val => {
          val.expandRowFlag = true;
        });
      }
      this.expandRowAllFlag = !this.expandRowAllFlag;
      this.refreshTable();

    },
    expandRow({ rowIndex }) {
      if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
      this.refreshTable();
    },
    
    getCurrent(item) {
      this.currentTab = item.data.id;
      if (this.currentTab === 0 && this.tableData.length > 100) {
        this.refreshTable();
      }
      if (this.currentTab === 1) {
        this.getNewScore();
      }
    },
    getNewScore() {
      // 更新平均分
      let param = { scoreId: this.scoreId };
      this.$ajax.post(this.$api.period.workScore.detailList, param).then((res) => {
        this.detail.avgkpi = res.data.workE.avgkpi;
      });
    },
    getCategory() {
      this.$ajax.get(this.$api.Identity.Categord.categoryByNo, { userId: sessionStorage.getItem('LOGIN_NAME') }).then((res) => {
        const item = res.data;
        this.categoryList = this.filterCategory(item);
      });
    },

    querySearch(queryString, cb) {
      let categoryList = this.categoryList;
      // 调用 callback 返回建议列表的数据
      let results = queryString ? categoryList.filter(this.createFilter(queryString)) : categoryList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (categoryList) => {
        return categoryList.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1;
      };
    },
    
    updateStatus(status) {
      if (this.status === 20) {
        //员工提交工作项目 待审批状态
        if (status == 'access') {
          this.showApprove = false;
          this.$ajax
            .post(this.$api.period.workScore.updateStatus, {
              scoreId: this.scoreId,
              status: 30,
              remark: this.approveReason,
              msgId: this.msgId,
            })
            .then((res) => {
              this.$message.success(res.message);
              this.reload();
            });
        } else {
          if (this.approveReason) {
            this.showCompleteApprove = false;
            this.$ajax
              .post(this.$api.period.workScore.updateStatus, {
                scoreId: this.scoreId,
                status: 10,
                remark: this.approveReason,
                msgId: this.msgId,
              })
              .then((res) => {
                this.$message.success(res.message);
                this.reload();
              });
          } else {
            this.$message.error('"驳回原因"为必填项');
          }
        }
      } else {
        this.$message.error('当前状态不能再被审批');
      }
    },
    
    closeApprove() {
      this.approveReason = '';
      this.approveRow = null;
    },
    
    expandNewKpi() {
      this.setMerge();
      this.expandNewKPIStatus = !this.expandNewKPIStatus;
      if (this.expandNewKPIStatus) {
        this.newKPI = _.cloneDeep(this.cloneNewKPI);
        this.cloneNewKPI = [];
      } else {
        this.cloneNewKPI = _.cloneDeep(this.newKPI);
        this.newKPI = [];
      }
    },
    expandImportantKPI() {
      this.setMerge();
      this.expandImportantKPIStatus = !this.expandImportantKPIStatus;
      if (this.expandImportantKPIStatus) {
        this.importantKPI = _.cloneDeep(this.cloneImportantKPI);
        this.cloneImportantKPI = [];
      } else {
        this.cloneImportantKPI = _.cloneDeep(this.importantKPI);
        this.importantKPI = [];
      }
    },
    expandBussiness() {
      this.setMerge();
      this.expandBussinessStatus = !this.expandBussinessStatus;
      if (this.expandBussinessStatus) {
        this.bussiness = _.cloneDeep(this.cloneBussiness);
        this.cloneBussiness = [];
      } else {
        this.cloneBussiness = _.cloneDeep(this.bussiness);
        this.bussiness = [];
      }
    },
    expandAll() {
      if (!this.expandNewKPIStatus) {
        this.expandNewKPIStatus = !this.expandNewKPIStatus;
        this.newKPI = _.cloneDeep(this.cloneNewKPI);
      }
      if (!this.expandImportantKPIStatus) {
        this.expandImportantKPIStatus = !this.expandImportantKPIStatus;
        this.importantKPI = _.cloneDeep(this.cloneImportantKPI);
      }
      if (!this.expandBussinessStatus) {
        this.expandBussinessStatus = !this.expandBussinessStatus;
        this.bussiness = _.cloneDeep(this.cloneBussiness);
      }
    },


    getList() {
      let param = { scoreId: this.scoreId };
      this.$ajax.post(this.$api.period.workScore.detailList, param).then((res) => {
        //判断审批状态下是否所有工作项内容都已审批过
        const result = res.data.detailEntitys || [];
        this.detail = res.data.workE;
        this.status = this.detail.status;

        this.newKPI = result.filter(item => item.type === 0);
        this.importantKPI = result.filter(item => item.type === 5);
        this.bussiness = result.filter(item => item.type === 10);
        
        if (this.importantKPI.length > 0) {
          this.itemLimitNums.kpiMax = this.itemLimitNums.haveImportKPIMax;
          this.hasImportKPI = true;
        } else {
          this.itemLimitNums.kpiMax = this.itemLimitNums.noImportKPIMax;
          this.hasImportKPI = false;
        }

        // 员工个人发展 分数
        let classifyScore = res.data.periodClassifyScoreInfo || [];
        if (classifyScore.length === 0) {
          classifyScore = [{workClassify: 100, score: null}, {workClassify: 110, score: null}, {workClassify: 120, score: null}]
        }
        classifyScore.forEach(item => {
          this.personalForm[item.workClassify] = item.score;
        });
        // 优缺点处理
        const advantage = this.detail.advantage ? JSON.parse(this.detail.advantage) : {};
        this.personalForm.advantage = advantage.checkList ? advantage.checkList : [];
        this.personalForm.otherAdvantage = advantage.other;
        this.submittedAdvantages = advantage.list || [];

        const disadvantage = this.detail.weakness ? JSON.parse(this.detail.weakness) : {};
        this.personalForm.disadvantage = disadvantage.checkList ? disadvantage.checkList : [];
        this.personalForm.otherDisadvantage = disadvantage.other;
        this.submittedDisadvantages = disadvantage.list || [];

        this.$nextTick(() => {
          this.refreshTable();
          this.setMerge();
          this.tableColumn = (this.$refs.workScoreTable && this.$refs.workScoreTable.getColumns()) || [];
        });
        if (result.length === 0) {
          if (this.isApproved || this.isConfirmed || this.isPublished) {
            this.tableData = [{}, {}, {}, {}, { isOutstandingCase: true }, {}, { isSelf: true }, {}, { isSup: true }];
          } else {
            this.tableData = [{}, {}, {}, {}, { isOutstandingCase: true }, {}, { isSelf: true }];
          }
        } else {
          this.tableData.forEach((val) => {
            val.expandRowFlag = false;
          });
        }
      });
    },
    getAdvantageDisAdvantage() {
      this.$ajax.get(this.$api.common.getDict, { ItemType: 'PeriodAdvantageWeakness' }).then((res)=>{
        if(res.code === 0) {
          let list = (res.data && res.data.rows) || [];
          list.forEach(item => {
            switch (item.itemKey) {
              case 'Advantage':
                var advantage = item.itemValue || '';
                this.advantages = advantage.split(',') || [];
                if (!this.advantages.includes('其他')) {
                  this.advantages.push('其他');
                }
                break;
              case 'Weakness':
                var weakness = item.itemValue || '';
                this.disadvantages = weakness.split(',') || [];
                if (!this.disadvantages.includes('其他')) {
                  this.disadvantages.push('其他');
                }
                break;
              default:
                break;
            }
          });
        }
      });
    },
    setMerge() {
      this.mergeCells = [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 3, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 4, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 5, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 5, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 6, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 6, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 7, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 7, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 8, col: 0, rowspan: 1, colspan: 5 },
        { row: this.newKPILength + this.importantKPILength + this.bussinessLength + 8, col: 5, rowspan: 1, colspan: this.tableColumnLength - 5 },
      ];
    },
    setRowClass({ rowIndex }) {
      if (
        rowIndex == 0 ||
        rowIndex == this.newKPILength + 1 ||
        rowIndex == this.newKPILength + this.importantKPILength + 2 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 3 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 5 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 7
      ) {
        return 'main-row';
      } else {
        // if ((row.status === 35 || row.status === 40) && (row.completeStatus !== 20 && row.completeStatus !== 25 )) {
        //   return 'unfinished';
        // }
      }
    },
    editActived({ row, rowIndex }) {
      if (this.isEditable) {
        // 引入的工作，到总结列都不能编辑
        if (row.type == 5) {
          this.colCategory = false;
          this.colWorkItem = false;
          this.colTarget = false;
          this.colSummary = false;
        } else {
          this.colCategory = true;
          this.colWorkItem = true;
          this.colTarget = true;
          this.colSummary = true;
        }
        if (row.isOutstandingCase) {
          this.colCase = true;
        } else {
          this.colCase = false;
        }
        if (
          rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 5 ||
          rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 7
        ) {
          this.colSummary = false;
        }
      } else {
        this.colCategory = false;
        this.colWorkItem = false;
        this.colTarget = false;
        if (row.isSup && this.isApproved) {
          this.colSummary = true;
          this.colCase = true;
        } else {
          this.colSummary = false;
          this.colCase = false;
        }
      }
      return true;
    },
    editClosed({ row, rowIndex }) {
      this.colCategory = true;
      this.colWorkItem = true;
      this.colTarget = true;
      this.colSummary = true;
      this.colCase = true;

      clearInterval(this.timer);
      if (
        rowIndex == 0 ||
        rowIndex == this.newKPILength + 1 ||
        rowIndex == this.newKPILength + this.importantKPILength + 2 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 3 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 5 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 7
      ) {
        return false;
      }
      if (row.isOutstandingCase || row.isSelf || row.isSup) {
        if (this.isEditable) {
          if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = false;
          this.refreshTable();
          this.saveSelfData();
        }
      } else if (rowIndex !== -1) {
        if (this.isEditable || this.isApproved) {
          if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = false;
          this.refreshTable();
          this.save(row, rowIndex);
        }
      }
    },
    activeRow({ row, rowIndex }) {
      if (row.isOutstandingCase || row.isSelf || row.isSup) return false;
      if (
        rowIndex == 0 ||
        rowIndex == this.newKPILength + 1 ||
        rowIndex == this.newKPILength + this.importantKPILength + 2 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 3 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 5 ||
        rowIndex == this.newKPILength + this.importantKPILength + this.bussinessLength + 7
      ) {
        return false;
      }
      this.row = row;
      this.rowIndex = rowIndex;
      clearInterval(this.timer);
      if (this.isEditable || this.isApproved) {
        this.timer = setInterval(() => {
          this.saveAuto(row, rowIndex);
        }, 10000);
      }
    },
    refreshTable() {
      this.$refs.workScoreTable && this.$refs.workScoreTable.updateData(this.tableData);
    },
    scoreSearch(queryString, cb) {
      let programList = this.scoreList;
      // 调用 callback 返回建议列表的数据
      cb(programList);
    },
    saveAll() {
      let arr = this.getAllTableData();
      this.$ajax.post(this.$api.period.workScore.addOrUpdate, arr, { noLoading: true }).then(() => {
        this.$message.success('保存成功');
      });
      if (this.isEditable || this.isApproved) {
        this.saveSelfData();
      }
    },
    async save(row, index) {
       if (this.autoSaving) {
        this.isPreventSave = true;
      } else {
        this.pending = true;
        this.isPreventSave = false;
        let params = this.tableData[index];
        await this.$ajax
          .post(this.$api.period.workScore.addOrUpdate, [params], { noLoading: true })
          .then((res) => {
            const item = res.data && res.data[0];
            if (!row.id) {
              row.id = item.id;
              row.scoreId = item.scoreId;
            }
            this.saveStatus = '已保存';
            this.timeoutSave && clearTimeout(timeoutSave);
            const timeoutSave = setTimeout(() => {
              this.saveStatus = '';
            }, 1000, this);
            this.pending = false;
            this.$nextTick(() => {
              this.setMerge();
            });
          })
          .catch(() => {
            this.pending = false;
          });
      }
    },
    saveSelfData() {
      this.pending = true;
      this.$ajax
        .post(this.$api.period.workScore.selfUpdate, this.detail, { noLoading: true })
        .then(() => {
          this.saveStatus = '已保存';
          this.timeoutSave && clearTimeout(timeoutSave);
          const timeoutSave = setTimeout(() => {
            this.saveStatus = '';
          }, 1000, this);
          this.pending = false;
        })
        .catch(() => {
          this.pending = false;
        });
    },
    async saveAuto(row, index) {
      if (row.isOutstandingCase || row.isSelf || row.isSup || row.id === undefined) return false;
      this.autoSaving = true;
      let params = this.tableData[index];
      await this.$ajax
        .post(this.$api.period.workScore.addOrUpdate, [params], { noLoading: true })
        .then((res) => {
          const item = res.data && res.data[0];
          if (!row.id) {
            row.id = item.id;
            row.scoreId = item.scoreId;
          }
          this.saveStatus = '已保存';
          this.timeoutAutoSave && clearTimeout(timeoutAutoSave);
          const timeoutAutoSave = setTimeout(() => {
            this.saveStatus = '';
          }, 1000, this);
          this.autoSaving = false;
          if(this.isPreventSave) {
            this.save(row, index);
          }
        })
        .catch(() => {
          this.autoSaving = false;
        });
    },
    
    deleteData(row) {
      if (row.id) {
        this.$ajax.delete(this.$api.period.workScore.deleteItem + '/' + row.id).then(() => {
          if (row.type === 0) {
            _.remove(this.newKPI, t => t.id == row.id);
            this.newKPI.splice(0, 0);
          } else if (row.type === 10){
            _.remove(this.bussiness, t => t.id == row.id);
            this.bussiness.splice(0, 0);
          }
          clearInterval(this.timer);
          this.$message.success('删除成功');
          this.setMerge();
        });
      } else {
        if (row.type === 0) {
          _.remove(this.newKPI, t => t.id == row.id);
          this.newKPI.splice(0, 0);
        } else if (row.type === 10){
          _.remove(this.bussiness, t => t.id == row.id);
          this.bussiness.splice(0, 0);
        }
        clearInterval(this.timer);
        this.$message.success('删除成功');
        this.setMerge();
      }
    },

    async addNewKpi() {
      if (!this.expandNewKPIStatus) {
        this.expandNewKPIStatus = true;
        this.newKPI = _.cloneDeep(this.cloneNewKPI);
        this.cloneNewKPI = [];
      }
      if (this.newKPILength >= this.itemLimitNums.kpiMax) {
        this.$message.error(`最多可添加${this.itemLimitNums.kpiMax}条数据`);
        return false;
      }
      const $table = this.$refs.workScoreTable;
      let kpiItem = _.cloneDeep(this.rowData);
      kpiItem.type = 0;
      this.newKPI.push(kpiItem);
      await $table.setActiveRow(this.tableData[this.newKPILength]);
    },
    async addBussiness() {
      if (!this.expandBussinessStatus) {
        this.expandBussinessStatus = true;
        this.bussiness = _.cloneDeep(this.cloneBussiness);
        this.cloneBussiness = [];
      }
      if (this.bussinessLength >= this.itemLimitNums.bussinessMax) {
        this.$message.error(`最多可添加${this.itemLimitNums.bussinessMax}条数据`);
        return false;
      }
      const $table = this.$refs.workScoreTable;
      let rowData = _.cloneDeep(this.rowData);
      rowData.type = 10;
      this.bussiness.push(rowData);
      await $table.setActiveRow(this.tableData[this.newKPILength + 2 + this.importantKPILength + this.bussinessLength]);
    },
    selfLevelChange() {
      this.saveSelfData();
    },
    supScoreChange(val, row, column) {
      if(!val && val !== 0) val = '';
      val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
      val = val && parseFloat(val);
      if (val - 0 > 100) {
        this.$message.error('综合评分分数不能大于100，您输入的值为' + val);
        val = 100;
        setTimeout(() => {
          this.$refs.workScoreTable.setActiveCell(row, column.property);
        }, 100);
      }
      if (val - 0 < 0) {
        val = 0;
      }
      this.detail.supScore = val;
      this.growUpSave();
    },
    async submit() {
      // 校验数据填写情况
      this.showSubmit = false;
      if (this.getAllTableData().length === 0) {
        this.$message.warning('请填写工作项后再提交');
        return false;
      }
      const validateObj = {};
      this.expandAll();
      this.setMerge();
      this.$nextTick(async () => {
        const data = this.tableData.filter((t, i) => t.id && i < this.newKPILength + this.importantKPILength + this.bussinessLength + 3);
        validateObj.value = data;
        
        const $table = this.$refs.workScoreTable;
        const errMap = await $table.validate(validateObj.value).catch((errMap) => errMap);
        Promise.all([errMap]).then((res) => {
          if (res[0]) {
            this.currentTab = 0;
            const msgList = [];
            Object.values(res[0]).forEach((errList) => {
              errList.forEach((params) => {
                const { rules } = params;
                rules.forEach((rule) => {
                  msgList.push(`校验错误：${rule.message}`);
                });
              });
            });
            this.$message({
              type: 'error',
              message: msgList.join(),
            });
            return false;
          }

          if (!this.detail.outstandingCase) {
            this.$message.error('"杰出案例"为必填项');
            return false;
          }
          if (!this.detail.selfEvaluation) {
            this.$message.error('"自评等级"为必填项');
            return false;
          }
          if (!this.detail.selfEvaluationReason) {
            this.$message.error('"自评原因"为必填项');
            return false;
          }
          
          if (this.status === 0 || this.status === 10) {
            this.$ajax.post(this.$api.period.workScore.submit, `"${this.scoreId}"`, { headers: { 'Content-Type': 'application/json;charset=UTF-8;' }}).then(() => {
              // 
              this.$message.success('提交成功');
              this.reload();
            });
          } else {
            this.showSubmit = false;
            this.$message.error('当前状态您的考核表已无法提交！');
          }
        });
      });
    },
    getAllTableData() {
      //获取所有工作项的数据
      let relResult = [];
      if (this.cloneNewKPI.length) {
        relResult = relResult.concat(this.cloneNewKPI);
      } else {
        relResult = relResult.concat(this.newKPI);
      }
      if (this.cloneImportantKPI.length) {
        relResult = relResult.concat(this.cloneImportantKPI);
      } else {
        relResult = relResult.concat(this.importantKPI);
      }
      if (this.cloneBussiness.length) {
        relResult = relResult.concat(this.cloneBussiness);
      } else {
        relResult = relResult.concat(this.bussiness);
      }
      return relResult;
    },
    scoreChange(val, key) {
      if(!val && val !== 0) val = '';
      val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
      val = val && parseFloat(val);
      if (val - 0 > 100) {
        this.$message.error('分数不能大于100，您输入的值为' + val);
        val = 100;
        setTimeout(() => {
          this.toFocusField(key);
        }, 100);
      }
      if (val - 0 < 0) {
        val = 0;
      }
      this.personalForm[key] = val;
      this.pending = true;
      let params = {
        wkNo: this.detail.wkNo,
        wkName: this.detail.wkName,
        year: this.detail.year,
        period: this.detail.period,
        workClassify: key,
        score: (this.personalForm[key] || this.personalForm[key] === 0) ? this.personalForm[key] : undefined,
      };
      this.$ajax
        .post(this.$api.period.workScore.growUpUpdateClassify, params, { noLoading: true })
        .then(() => {
          this.saveStatus = '已保存';
          this.timeoutSave && clearTimeout(timeoutSave);
          const timeoutSave = setTimeout(() => {
            this.saveStatus = '';
          }, 1000, this);
        })
        .finally(() => {
          this.pending = false;
        });

    },
    checkedAdvantageChange() {
      if (!this.personalForm.advantage.includes('其他')) {
        this.personalForm.otherAdvantage = '';
      }
      this.growUpSave();
    },
    checkedDisadvantageChange() {
      if (!this.personalForm.disadvantage.includes('其他')) {
        this.personalForm.otherDisadvantage = '';
      }
      this.growUpSave();
    },
    toFocusField(key) {
      if (this.isApproved) {
        this.defaultScore[key] = false;
        this.$nextTick(() => {
          this.$refs['score' + key].focus();
        });
      }
    },
    blurField(key) {
      this.defaultScore[key] = true;
    },
    
    growUpSave() {
      this.pending = true;
      this.detail.advantage = JSON.stringify({
        checkList: this.personalForm.advantage,
        other: this.personalForm.otherAdvantage,
        list: this.personalAdvantages
      });
      this.detail.weakness = JSON.stringify({
        checkList: this.personalForm.disadvantage,
        other: this.personalForm.otherDisadvantage,
        list: this.personalDisadvantages
      });
      return this.$ajax
        .post(this.$api.period.workScore.growUpUpdate, { ...this.detail, supScore: this.detail.supScore === '' ? null : this.detail.supScore }, { noLoading: true })
        .then(() => {
          this.saveStatus = '已保存';
          this.timeoutSave && clearTimeout(timeoutSave);
          const timeoutSave = setTimeout(() => {
            this.saveStatus = '';
          }, 1000, this);
        })
        .finally(() => {
          this.pending = false;
        });
    },
    validateGrowUpTable() {
      if (!this.personalForm[100]) {
        this.$message.error('"绩效得分"为必填项');
        return false;
      }
      if (!this.personalForm[110]) {
        this.$message.error('"企业文化导向得分"为必填项');
        return false;
      }
      if (!this.personalForm[120]) {
        this.$message.error('"个人成长得分"为必填项');
        return false;
      }
      if (this.personalForm.advantage.length === 0) {
        this.$message.error('"优点"为必填项');
        return false;
      }
      if (this.personalForm.advantage.includes('其他') && !this.personalForm.otherAdvantage) {
        this.$message.error('"其他优点"为必填项');
        return false;
      }
      if (this.personalForm.disadvantage.length === 0) {
        this.$message.error('"缺点"为必填项');
        return false;
      }
      if (this.personalForm.disadvantage.includes('其他') && !this.personalForm.otherDisadvantage) {
        this.$message.error('"其他缺点"为必填项');
        return false;
      }
      if (!this.detail.lastImprovePlan) {
        this.$message.error('"上期改进计划"为必填项');
        return false;
      }
      if (!this.detail.improveDetail) {
        this.$message.error('"改进情况"为必填项');
        return false;
      }
      if (!this.detail.problem) {
        this.$message.error('"存在的问题"为必填项');
        return false;
      }
      if (!this.detail.improvePlan) {
        this.$message.error('"员工绩效改进计划"为必填项');
        return false;
      }
      return true;
    },
    validateSup() {
      if (!this.detail.supScore && this.detail.supScore !== 0) {
        this.$message.error('"综合评分"为必填项');
        return false;
      }
      if (!this.detail.supEvaluation) {
        this.$message.error('"综合评价"为必填项');
        return false;
      }
      return true;
    },
    showConfirmScore() {
      this.isShowConfirmScore = true;
    },
    async confirmScore() {
      if (this.currentTab === 1 && !this.validateGrowUpTable()) {
        return false;
      }
      const validateObj = {};
      const data = this.tableData.filter((t, i) => t.id && i < this.newKPILength + this.importantKPILength + this.bussinessLength + 3);
      validateObj.value = data;
      
      const $table = this.$refs.workScoreTable;
      const errMap = await $table.validate(validateObj.value).catch((errMap) => errMap);
      Promise.all([errMap]).then((res) => {
        if (res[0]) {
          this.currentTab = 0;
          const msgList = [];
          Object.values(res[0]).forEach((errList) => {
            errList.forEach((params) => {
              const { rules } = params;
              rules.forEach((rule) => {
                msgList.push(`校验错误：${rule.message}`);
              });
            });
          });
          this.$message({
            type: 'error',
            message: msgList.join(),
          });
          return false;
        }

        if (!this.validateSup()) {
          this.currentTab = 0;
          return false;
        }

        if (this.currentTab === 0 && !this.validateGrowUpTable()) {
          this.currentTab = 1;
          this.getNewScore();
          return false;
        }

        this.pending = true;
        this.$ajax
          .post(this.$api.period.workScore.growUpConfirm, `"${this.scoreId}"`, { headers: { 'Content-Type': 'application/json;charset=UTF-8;' }})
          .then((res) => {
            this.$message.success(res.message);
            this.reload();
          })
          .finally(() => {
            this.pending = false;
          });
      });

    },
    exportExcel() {
      let param = { ScoreId: this.scoreId };

      let apiURL = this.$api.period.workScore.selfExport;
      if (this.editStatus === 'approve') {
        apiURL = this.$api.period.workScore.export;
      }

      this.$ajax.get(apiURL, param, { ignore: true, responseType: 'blob' }).then((res) => {
        if (res.data.type == 'application/json') {
          var reader = new FileReader();
          reader.onload = () => {
            var content = reader.result; //内容就在这里
            let json = JSON.parse(content);
            this.$message.error(json.message);
          };
          reader.readAsText(res.data);
        } else {
          const filename = `${this.detail.year}${this.periods[this.detail.period]}员工绩效考核表`;
          const filetype = 'xlsx';
          let data = res.data;
          let url = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = filename + '.' + filetype;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },
  },
  
};
</script>
<style scoped lang="scss">
.workscore-detail {
  height: 100%;
  .header {
    margin-top: -5px;
    .month-title {
      padding: 0 10px;
      line-height: 30px;
      h2 {
        color: $--color-text-primary;
        font-size: 18px;
        font-weight: bold;
        display: inline-block;
      }
      .saveStatus {
        margin-left: 10px;
        font-size: 15px;
        color: #8e9694;
      }
    }
  }
  .container {
    margin-top: 15px;
    padding: 20px;
    flex: 1;
    .tab {
      .el-icon-arrow-down {
        font-size: 12px;
      }
      .open {
        padding-top: 8px;
        font-size: 14px;
        color: #859291;
        cursor: pointer;
      }
    }
    .search-and-content {
      flex: 1;
      overflow: auto;
      .search {
        .function{
          flex-wrap: wrap;
        }
      }
      
      .atb-input {
        display: flex;
        .flex-form-item {
          margin-bottom: 12px;
          display: flex;
          flex: 1;
        }
        .read-mode {
          align-self: flex-end;
        }
        ::v-deep.el-form-item__content {
          flex: 1;
          .el-select,
          .el-autocomplete {
            width: 100%;
          }
        }
      }
    }

    ::v-deep .header-table {
      overflow: auto;
      flex-grow: 1;
      user-select: text;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .main-row {
        .vxe-cell {
          padding: 0;
        }
      }
      .unfinished {
        .vxe-cell{
          color: rgb(254, 107, 104);
        }
      }
    }
    .kpi-add {
      height: 47px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      padding: 0 15px;
      div {
        cursor: pointer;
        span {
          margin-right: 15px;
        }
        i.fold {
          margin-right: 5px;
        }
      }
      span {
        cursor: pointer;
      }
    }
  }
  ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: $--color-primary;
  }
  ::v-deep .el-dialog__body {
    padding-top: 33px !important;
    text-align: left;
    .sub-content {
      text-align: center;
    }
    h2 {
      font-size: 18px;
      color: $--color-text-primary;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: $--color-text-regular;
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: right;
  }
  .normal-form {
    width: 80%;
  }
  ::v-deep .el-input-group__append {
    padding: 0 5px;
  }
}

::v-deep .el-radio-button {
  margin-right: 20px;
  margin-bottom: 15px;
  .el-radio-button__inner {
    border-radius: 20px;
    padding: 0 20px;
    width: 100%;
    line-height: 36px;
    border: 1px solid $--color-primary;
    color: $--color-primary;
  }
}
::v-deep .el-radio-button.is-active .el-radio-button__inner {
  color: $--color-white;
}

.footer {
  text-align: right;
  margin-top: 20px;
  .select-all-program {
    margin-right: 20px;
  }
}

.personal-table {
  border-collapse: collapse;
  font-size: 14px;
  .label-row {
    background-color: #f6f7fb;
  }
  td {
    padding: 5px 10px;
    border: 1px solid #dcdfe6;
  }
  .personal-label {
    padding: 8px 0;
    color: $--color-primary;
  }

  .checkbox-group {
    display: inline-block;
    margin: 0 10px;
  }
  .other-field {
    margin-top: 8px;
  }
  .area-label {
    white-space: nowrap;
    width: 115px;
  }
  .default-score {
    height: 40px;
    line-height: 40px;
  }
  ::v-deep .el-textarea.is-disabled .el-textarea__inner {
    color: #555;
  }
  ::v-deep .el-input.is-disabled .el-input__inner {
    color: #555;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: $--color-primary;
  }
}
.rank-tip {
  color: $--color-primary;
}
.rank-tip-table {
  border-collapse: collapse;
  font-size: 13px;
  color: #222;
  td, th {
    padding: 10px ;
    border: 1px solid #ccc;
  }
}
.radio-group {
  margin-left: 40px;
}
.required-field {
  &::before {
    content: '*';
    color: #f56c6c;
    font-size: 14px;
    padding-right: 4px;
    font-family: Verdana, Arial, Tahoma;
    vertical-align: -2px;
  }
}
::v-deep .footer-center .el-dialog__footer {
  text-align: center;
}
</style>
